export default __webpack_public_path__ + "static/Screenshot8-88c37471a5bbf297ffc0faf834b89e01.jpg";